import { createSlice } from '@reduxjs/toolkit'

export const mapReadySlice = createSlice({
  name: 'mapReady',
  initialState: {
    value: false,
  },
  reducers: {
    toggleMapReady: (state, action) => {
    
      state.value =action.payload
    },
   
  },
})

// Action creators are generated for each case reducer function
export const { toggleMapReady } = mapReadySlice.actions

export default mapReadySlice.reducer